/**
 * Agent Module
 */
import helper from 'util/helpers'
import moment from 'moment'
const getDefaultState = () => {
  return {
    agentId: null,
    ticketAgentId: null,
    agentWorkingStatus: null,
    authorities: null,
    email: null,
    loginId: null,
    name: null,
    agentMappingBrandViews: [],
    currentBrandId: null,
    currentBrandName: null,
    currentTicketBrandId: null,
    currentTicketBrandName: null,
    customTemplates: [],
    updatedCustomerInfos: [],
    treeNodeSelectedItem: {},
    currentParentBrandId: null,
    moduleChannelId: null,
    planAccountCount: null,
    planType: null,
    oldPlanType: null,
    oldPlanAccountCount: null,
    billingStartDate: null,
    isFuncLv1: false,
    isFuncLv2: false,
    nextPlanType: null,
    nextPlanAccountCount: null,
    isNextPayment: false
  }
}
const state = getDefaultState()

const getters = {
  agentId: (state) => {
    return state.agentId
  },
  email: (state) => {
    return state.email
  },
  name: (state) => {
    return state.name
  },
  agentMappingBrandViews: (state) => {
    return state.agentMappingBrandViews
  },
  isPossibleWaitingCategory: (state) => (chatRoomCategoryId) => {
    let categories = state.agentMappingBrandViews.map(view => view.categoryIds).flatten()
    if (categories.includes(chatRoomCategoryId)) { return true }
    return false
  },
  ticketAgentId: (state) => {
    return state.ticketAgentId
  },
  loginId: (state) => {
    return state.loginId
  },
  authorities: (state) => {
    return state.authorities
  },
  customTemplates: (state) => {
    return state.customTemplates
  },
  agentWorkingStatus: (state) => {
    return state.agentWorkingStatus
  },
  currentBrandId: (state) => {
    return state.currentBrandId
  },
  currentBrandName: (state) => {
    return state.currentBrandName
  },
  currentTicketBrandId: (state) => {
    return state.currentTicketBrandId
  },
  currentTicketBrandName: (state) => {
    return state.currentTicketBrandName
  },
  updatedCustomerInfos: (state) => {
    return state.updatedCustomerInfos
  },
  getUpdatedCustomerInfo: (state) => (userKey) => {
    return state.updatedCustomerInfos.find(customerInfo => userKey === customerInfo.userKey)
  },
  findCustomerName: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find(customerInfo => customerInfoView.userKey === customerInfo.userKey)
    return helper.longTextLengthAdjust(customerInfos && customerInfos.name ? customerInfos.name : customerInfoView.name ? customerInfoView.name : customerInfoView.userKey, 4)
  },
  findCustomerPhoneNumber: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find(customerInfo => customerInfoView.userKey === customerInfo.userKey)
    return customerInfos && customerInfos.phoneNumber ? customerInfos.phoneNumber : customerInfoView.phoneNumber ? customerInfoView.phoneNumber : undefined
  },
  findCustomerFullName: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find(customerInfo => customerInfoView.userKey === customerInfo.userKey)
    return customerInfos && customerInfos.name !== undefined && customerInfos.name ? customerInfos.name
      : customerInfoView.name !== undefined && customerInfoView.name ? customerInfoView.name : customerInfoView.userKey
  },
  findCustomerEmail: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find(customerInfo => customerInfoView.userKey === customerInfo.userKey)
    return customerInfos && customerInfos.email ? customerInfos.email : customerInfoView.email ? customerInfoView.email : undefined
  },
  findCustomerUserKey: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find(customerInfo => customerInfoView.userKey === customerInfo.userKey)
    return customerInfos && customerInfos.userKey ? customerInfos.userKey : customerInfoView.userKey ? customerInfoView.userKey : undefined
  },
  findCustomerMemo: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find(customerInfo => customerInfoView.userKey === customerInfo.userKey)
    return customerInfos && customerInfos.memo ? customerInfos.memo : customerInfoView.memo ? customerInfoView.memo : undefined
  },
  findCustomerChannelName: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find(customerInfo => customerInfoView.channelName === customerInfo.channelName)
    return customerInfos && customerInfos.channelName ? customerInfos.channelName : customerInfoView.channelName ? customerInfoView.channelName : undefined
  },
  treeNodeSelectedItem: (state) => {
    return state.treeNodeSelectedItem
  },
  currentParentBrandId: (state) => {
    return state.currentParentBrandId
  },
  moduleChannelId: (state) => {
    return state.moduleChannelId
  },
  planAccountCount: (state) => {
    return state.planAccountCount
  },
  oldPlanAccountCount: (state) => {
    return state.oldPlanAccountCount
  },
  nextPlanAccountCount: (state) => {
    return state.nextPlanAccountCount
  },
  planType: (state) => {
    return state.planType
  },
  oldPlanType: (state) => {
    return state.oldPlanType
  },
  nextPlanType: (state) => {
    return state.nextPlanType
  },
  billingStartDate: (state) => {
    return state.billingStartDate
  },
  freeDate: (state) => {
    let start = moment(moment(helper.printTimeStampYYYYMMDDFromDateTime(state.billingStartDate)).format('YYYY-MM-DD'))
    let end = moment(moment(start).add(14, 'day').format('YYYY-MM-DD'))
    let now = moment(moment(new Date()).format('YYYY-MM-DD'))
    let duration = moment.duration(end.diff(now)).asDays()
    return duration < 1 ? 0 : duration
  },
  isFuncLv1: (state) => {
    return state.isFuncLv1
  },
  isFuncLv2: (state) => {
    return state.isFuncLv2
  },
  isFreePlan: (state) => {
    return state.isFreePlan
  },
  isNextPayment: (state) => {
    return state.isNextPayment
  }
}

const actions = {
}

const mutations = {
  setAgentState (state, parsedInfo) {
    this.$token = parsedInfo || null
    state.agentId = parsedInfo.agentId
    state.loginId = parsedInfo.loginId
    state.name = parsedInfo.name
    state.email = parsedInfo.email
    state.authorities = parsedInfo.authorities
    state.ticketAgentId = parsedInfo.ticketAgentId
    state.agentMappingBrandViews = parsedInfo.agentMappingBrandViews
    state.currentBrandId = parsedInfo.agentMappingBrandViews[0].brandId
    if (parsedInfo.billingBrandAgentView) {
      state.planAccountCount = parsedInfo.billingBrandAgentView.agentCount
      state.planType = parsedInfo.billingBrandAgentView.planType
      state.oldPlanAccountCount = parsedInfo.billingBrandAgentView.oldAgentCount
      state.oldPlanType = parsedInfo.billingBrandAgentView.oldPlanType
      state.billingStartDate = parsedInfo.billingBrandAgentView.billingStartDate
      state.isFuncLv1 = parsedInfo.billingBrandAgentView.isFuncLv1
      state.isFuncLv2 = parsedInfo.billingBrandAgentView.isFuncLv2
      state.isFreePlan = parsedInfo.billingBrandAgentView.isFreePlan
      if (parsedInfo.billingBrandAgentView.nextMonth) {
        state.isNextPayment = true
        state.nextPlanType = parsedInfo.billingBrandAgentView.nextMonth.planType
        state.nextPlanAccountCount = parsedInfo.billingBrandAgentView.nextMonth.agentCount
      }
    }
  },
  setPlanAccountCount (state, count) {
    state.planAccountCount = state.planAccountCount + count
  },
  setNextPlanAccountCount (state, count) {
    state.nextPlanAccountCount = state.nextPlanAccountCount + count
  },
  setPlanType (state, type) {
    state.planType = type
  },
  setAgentWorkingStatus (state, workingStatus) {
    state.agentWorkingStatus = workingStatus
  },
  setCustomTemplates (state, payload) {
    if (Array.isArray(payload)) {
      state.customTemplates = payload
    } else if (typeof payload === 'object') {
      const oneKey = state.customTemplates.find(template => template.templateId === payload.templateId)
      if (!oneKey) {
        state.customTemplates.push(payload)
        return
      }
      oneKey.message = payload.message
    }
  },
  deleteCustomTemplate (state, customTemplateInfo) {
    state.customTemplates.splice(state.customTemplates.indexOf(customTemplateInfo), 1)
  },
  changeCurrentBrandId (state, brandId) {
    state.currentBrandId = brandId
  },
  changeCurrentBrandName (state, brandName) {
    state.currentBrandName = brandName
  },
  changeTicketBrandId (state, brandId) {
    state.currentTicketBrandId = brandId
  },
  changeTicketBrandName (state, brandName) {
    state.currentTicketBrandName = brandName
  },
  changeName (state, name) {
    state.name = name
  },
  pushUpdateCustomerInfo (state, payload) {
    let index = state.updatedCustomerInfos.findIndex(customerInfo => payload.userKey === customerInfo.userKey)
    if (index === -1) {
      state.updatedCustomerInfos.push(payload)
    } else {
      state.updatedCustomerInfos[index] = payload
      state.updatedCustomerInfos.push()
    }
  },
  CLEAR_AGENT (state) {
    Object.assign(state, getDefaultState())
  },
  changeTreeNodeSelectedItem (state, payload) {
    state.treeNodeSelectedItem = payload
  },
  changeCurrentParentBrandId (state, brandId) {
    state.currentParentBrandId = brandId
  },
  changeModuleChannelId (state, brandId) {
    state.moduleChannelId = brandId
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agent/index.js